import { Link } from 'react-router-dom';
import { InstagramLogo, TiktokLogo } from '@phosphor-icons/react';

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-border" data-testid="footer">
      <div className="px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <h2 
              className="text-4xl font-bold tracking-tighter uppercase mb-4"
              style={{ fontFamily: "'Oswald', sans-serif" }}
            >
              THREADS
            </h2>
            <p className="text-muted-foreground text-sm max-w-md leading-relaxed">
              STREETWEAR COLLECTIVE // REDEFINING URBAN FASHION SINCE 2024.
              RAW. BOLD. UNAPOLOGETIC.
            </p>
          </div>

          {/* Shop Links */}
          <div>
            <h3 
              className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-6"
            >
              SHOP
            </h3>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/shop/men" 
                  className="text-sm hover:text-primary transition-colors"
                  data-testid="footer-shop-link"
                >
                  ALL PRODUCTS
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 
              className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-6"
            >
              CONTACT
            </h3>
            <a 
              href="mailto:1209apparel@gmail.com"
              className="text-sm hover:text-primary transition-colors block mb-4"
              data-testid="contact-email"
            >
              1209apparel@gmail.com
            </a>
            <a 
              href="tel:305-384-8076"
              className="text-sm hover:text-primary transition-colors block mb-4"
              data-testid="contact-phone"
            >
              305-384-8076
            </a>
            <p className="text-xs text-muted-foreground mt-4">
              SPECIAL CUSTOM T-SHIRTS
            </p>
            <p className="text-xs text-muted-foreground">
              EMAIL, TEXT OR CALL
            </p>
          </div>

          {/* Social */}
          <div>
            <h3 
              className="text-xs uppercase tracking-[0.2em] font-bold text-muted-foreground mb-6"
            >
              CONNECT
            </h3>
            <div className="flex gap-4">
              <a 
                href="https://instagram.com/1209_apparel" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 border border-border hover:border-primary hover:text-primary transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <InstagramLogo size={20} />
              </a>
              <a 
                href="https://tiktok.com/@1209apparel" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 border border-border hover:border-primary hover:text-primary transition-colors"
                data-testid="social-tiktok"
                aria-label="TikTok"
              >
                <TiktokLogo size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} THREADS. ALL RIGHTS RESERVED.
          </p>
          <p className="text-xs text-muted-foreground">
            DESIGNED WITH RAW ENERGY
          </p>
        </div>
      </div>
    </footer>
  );
};
